import base from './base';
import { permissionComputeds } from './base';

export default {
	mixins: [base],
	computed: permissionComputeds('VIEW_LICENCE', 'ACTIVATE_LICENCE'),
};
